import React from 'react';
import Layout from '../../../components/layouts/Layout';
import { useTranslation } from 'react-i18next';
import CategoriesSection from '../../../components/store/reusable/category/CategoriesSection';
import { useParams, useSearchParams } from 'react-router-dom';
import ProductListWrapper from '../../../components/store/products/ProductListWrapper';
import { useProductCategories } from '../../../hooks/store/productCategory';
import Pagination from '../../../components/ui/Pagination';
import { useStoreProducts } from '../../../hooks/store/product';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import EmptyData from '../../../components/ui/EmptyData';
import { formatNumber } from '../../../utils/formatNumber';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { PermissionsKey } from '../../../data/permissions';

const StoreProductsOverView: React.FC = () => {
      const { storeId} = useParams<{ storeId: string}>();
      const numericStoreId = storeId ? parseInt(storeId) : undefined;
      const { t } = useTranslation();
      const [searchParams,setSearchParams] = useSearchParams();
      const category = Number(searchParams.get('category'));
      const pageQuery = Number(searchParams.get('page')) || 1;
      const {data:categories} = useProductCategories(numericStoreId);

      const handlePagination = (page: number) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', page.toString());
        setSearchParams(newParams);
    };
    const {data:products , isLoading, isError,error} = useStoreProducts({categoryId:category,page:pageQuery,storeId:numericStoreId});

    const adminPermissions = useSelector((s:RootState)=>s.admin.permissions)
    const store = useSelector((s:RootState)=>s.store)


  return (
    <Layout title={t("layout_titles.products")} headline={t('products_headline',{num:formatNumber(products?.data.length??0)})}>
      <CategoriesSection
        selectedCategory={category?category.toString():""}
        categories={categories? categories?.map(ca=>({name:ca.languages[0].title, id:ca.id})):[]}
        buttonAddLinkPath={storeId?`/admin/stores/${numericStoreId}/add-category`:"/store/add-category"}
        buttonLinkPath={storeId? `/admin/stores/${numericStoreId}/add-product`:"add-product"}
        buttonLabel='add_new_product'
        showAdd={store?true:adminPermissions.includes(PermissionsKey.CreateStoreCategory)}
        notShowAddButton={store?false:!adminPermissions.includes(PermissionsKey.CreateProduct)}
      />
      <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      errorMessage={error?.message}
      />
      {products && (products.data.length===0 
        ? <EmptyData/> 
        :
        <>
          <ProductListWrapper products={products.data}/>
           <Pagination
           currentPage={pageQuery}
          totalPages={products?.totalPages||0}
          handlePagination={handlePagination}
          />
        </>
        )}
    </Layout>
  );
};

export default StoreProductsOverView;
